import UserPermissionTypes from '@constants/permissions';
import { AddMembersTabType } from '@features/group-management/constants';
import { TabPill } from 'types/tabs';

const hasPermission = (
  userPermissions: string[] | undefined,
  permission: string
): boolean => !!userPermissions?.includes(permission);

/** Member list tab — branch_member_view */
export const canAccessMemberListTab = (
  userPermissions: string[] | undefined
): boolean =>
  hasPermission(userPermissions, UserPermissionTypes.BRANCH_MEMBER_VIEW);

/** Group list tab — group_member_view */
export const canAccessGroupListTab = (
  userPermissions: string[] | undefined
): boolean =>
  hasPermission(userPermissions, UserPermissionTypes.GROUP_MEMBER_VIEW);

/**
 * Import / add manually — group_member_create when adding to a group,
 * otherwise branch_member_create.
 */
export const canAccessCreateOrImportMemberTab = (
  userPermissions: string[] | undefined,
  isGroupContext: boolean
): boolean =>
  hasPermission(
    userPermissions,
    isGroupContext
      ? UserPermissionTypes.GROUP_MEMBER_CREATE
      : UserPermissionTypes.BRANCH_MEMBER_CREATE
  );

export const canAccessAddMemberTab = (
  tabId: string | number,
  userPermissions: string[] | undefined,
  isGroupContext: boolean
): boolean => {
  switch (tabId) {
    case AddMembersTabType.ADD_FROM_MEMBER_LIST:
      return canAccessMemberListTab(userPermissions);
    case AddMembersTabType.ADD_FROM_GROUP:
      return canAccessGroupListTab(userPermissions);
    case AddMembersTabType.IMPORT_FILE:
    case AddMembersTabType.ADD_MANUALLY:
      return canAccessCreateOrImportMemberTab(userPermissions, isGroupContext);
    default:
      return true;
  }
};

export const filterAddMemberTabs = (
  tabs: TabPill[],
  userPermissions: string[] | undefined,
  isGroupContext: boolean
): TabPill[] =>
  tabs.filter((tab) =>
    canAccessAddMemberTab(tab.id, userPermissions, isGroupContext)
  );

/** Group create / group-context Add Members tabs. */
export const filterGroupAddMemberTabs = (
  tabs: TabPill[],
  userPermissions: string[] | undefined
): TabPill[] => filterAddMemberTabs(tabs, userPermissions, true);
